<template>
  <header>
    <div class="header">
      <div class="header-left">
        <slot name="left"></slot>
      </div>
      <div class="header-center">
        <h1 class="header-title">{{ title }}</h1>
      </div>
      <div class="header-right">
        <slot name="right"></slot>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Main-Header',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.header {
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  width: 100%;
  height: 60px;
}

.light-theme header {
  background: #ffffff;
}

.dark-theme header {
  background: #171e29;
  color: white;
}

header div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cat-transaction-header .header-title {
  white-space: nowrap;
  font-size: 1.3em;
  line-height: 1.3em;
}

.header-title {
  margin: 0;
  text-align: center;
  flex-grow: 1;
  font-size: 1.5em;
  display: flex;
  justify-content: center;
}

.header-left {
  padding-left: 1em;
  justify-content: start;
}

.header-left svg {
  font-size: 1.5em;
}

.header-right {
  padding-right: 1em;
  justify-content: right;
}

@media screen and (min-width: 992px) {
  .header {
    height: 100px;
  }
}
</style>
